export const DEFAULT_DISTRIBUTION_OPTION = { value: "default", label: "Even Distribution (default)" };
